var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import "blocks/AggregatesGamesBlock/ui/AggregatesGamesBlock.less";
// external components
import { Loader } from "sb-resp-ui";
// block components
import * as CMP from "../components";
let AggregatesGamesBlock = class AggregatesGamesBlock extends React.Component {
    constructor(props) {
        super(props);
        // setup dictionary
        this.dict = props.dict;
        // setup data provider
        this.state = {
            dataProvider: props.dataProvider
        };
    }
    render() {
        const { aggregatedParticipants1, aggregatedParticipants2, games } = this.state.dataProvider.gameData;
        return (this.state.dataProvider.isDataLoaded
            ?
                React.createElement("div", { className: "rj-aggregate-matches" },
                    React.createElement(CMP.GameHeading, { participant1: aggregatedParticipants1, participant2: aggregatedParticipants2 }),
                    games.map(g => (React.createElement(CMP.GameItem, { key: `game-id-${g.id}`, dict: this.dict, game: g }))))
            : React.createElement("div", { className: "rj-aggregate-matches" },
                React.createElement(Loader, null)));
    }
};
AggregatesGamesBlock = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], AggregatesGamesBlock);
export { AggregatesGamesBlock };
//# sourceMappingURL=AggregatesGamesBlock.js.map